import { toast } from "@/hooks/use-toast"
import { copyText } from "@/lib/clipboard"

import { absoluteUrl } from "./urls"

/**
 * Copy a receipt link to the clipboard and report the outcome.
 *
 * One definition for all four call sites — the whole-invoice copy on the
 * detail action row and again in the list row menu, the per-leg copy on
 * the deposit panel, and the per-charge copy on each settled row of the
 * rep schedule table — because the design fixes *one* label and *one*
 * toast pair for the set, and four hand-written copies would each be a
 * place for that decision to drift.
 *
 * The ``absoluteUrl`` wrap lives here rather than at the call sites: the
 * path builders are deliberately relative, since they were written for
 * ``href`` attributes, and a *copied* link is pasted somewhere with no
 * origin of its own. Callers pass a path; this makes it shareable.
 */
export async function copyReceiptLink(path: string): Promise<void> {
  const ok = await copyText(absoluteUrl(path))
  toast(
    ok
      ? {
          title: "Receipt link copied",
          description:
            "Share it with the customer — it opens the receipt PDF.",
        }
      : {
          // Deliberately not the pay/portal links' "Copy the URL from the
          // address bar instead": a receipt URL is never in the address bar.
          title: "Could not copy",
          description: "Please try again.",
          variant: "destructive",
        },
  )
}
